import React from "react";

import { useLocalStorage } from "./useLocalStorage";

import { useSidebarLayoutContext } from "contexts/SidebarLayoutContext";

export const useSidebarSettings = (key) => {
  const [sidebarSettings, setSidebarSettings] = useLocalStorage(
    "FSW_SIDE_BAR_SETTINGS",
    {}
  );

  const { setShowSidebar, isMobile } = useSidebarLayoutContext();

  const sidebarShown = sidebarSettings[key] ?? false;

  const toggleSidebarSettings = () => {
    setSidebarSettings({ ...sidebarSettings, [key]: !sidebarShown });
  };

  React.useEffect(() => {
    if (!key) return () => setShowSidebar(!isMobile);

    setShowSidebar(sidebarSettings[key]);

    return () => setShowSidebar(!isMobile);
  }, [sidebarSettings, setShowSidebar, key, isMobile]);

  return { sidebarShown, toggleSidebarSettings };
};
